// extracted by mini-css-extract-plugin
export default {"content":"styles_content__0Lqcz","headText":"styles_headText__N9tuF","bodyText":"styles_bodyText__AQs79","linksWrap":"styles_linksWrap__zyzcW"};